/* eslint-disable @typescript-eslint/camelcase */
import { OperatorTokenFields } from 'modules/operators/interfaces';

export const initialValues: OperatorTokenFields = {
  description: '',
  expiration_date: null,
  partner_uuid: '',
  filter_using_ips: false,
  valid_ips: [],
};
